export default __webpack_public_path__ + "static/data_port_b.a515b29b054274abc7aef23ae4af6ae6.png";